<ng-container *ngIf="(hasError$ | async) === false">
  <ng-container
    *ngIf="{
      product: (product$ | async) ?? {},
      showBackToSolutionLink: showBackToSolutionLink() | async,
      configuration: configuration$ | async,
    } as data">
    <div *ngIf="data.showBackToSolutionLink" id="configureHeader">
      <div class="row mb-8">
        <div class="col-12 col-sm-2 col-md-3 udex-mb-32 udex-mb-lg-24">
          <div>
            <udex-link
              icon="slim-arrow-left"
              icon-placement="Start"
              [href]="(getBackToSolutionPageURL() | async) ?? ({cxRoute: 'product', params: data.product} | cxUrl)"
              tabindex="0"
              (click)="onLinkClick($event)">
              <span class="d-none d-lg-inline navigation__medium--xl">
                {{ 'configurator.backToSolutionPage' | cxTranslate }}
              </span>
              <span class="d-lg-none navigation__medium--xl">
                {{ 'configurator.backToSolutionPageMobile' | cxTranslate }}
              </span>
            </udex-link>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="data?.configuration || data?.product">
      <div class="row">
        <div class="col-md-7 col-12">
          <div class="row">
            <div class="col-12 configurator-headline" data-cy="cps-configurator-headline">
              <span class="heading__regular--s">{{ 'configurator.configureYourSolution' | cxTranslate }} </span>
              <span class="heading__medium--s">{{ data?.configuration?.productName || data?.product?.name }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-5 col-12"></div>
      </div>
    </div>

    <dcp-configurator-leave-page-confirmation-modal
      [open]="openConfirmationModal"
      (continue)="onConfirm(data.product)"
      (cancel)="onCancel()">
    </dcp-configurator-leave-page-confirmation-modal>
  </ng-container>
</ng-container>
